<template>
	<div class="flex flex-col gap-1">
		<div v-if="props.label" class="pl-1 text-sm">
			{{ props.label }}
		</div>
		<ion-textarea v-bind="$attrs" :label="undefined" />
	</div>
</template>

<script setup lang="ts">
	import { IonTextarea } from "@ionic/vue";

	interface SgTextareaProps {
		label?: string;
	}
	const props = defineProps<SgTextareaProps>();

	defineOptions({
		inheritAttrs: true,
	});
</script>

<style scoped>
	ion-textarea {
		--background: #eee;
		--padding-start: 0.5rem;
		--padding-end: 0.5rem;
		--border-radius: 0.5rem;
	}
</style>
